
namespace Gamification.Gamification {
    export class ProdottiParametriGlobaliColumns {
        static columnsKey = 'Gamification.ProdottiParametriGlobali';
    }
}